import { render, staticRenderFns } from "./RemarkInfo.vue?vue&type=template&id=3488217c&"
import script from "./RemarkInfo.vue?vue&type=script&lang=js&"
export * from "./RemarkInfo.vue?vue&type=script&lang=js&"
import style0 from "./RemarkInfo.vue?vue&type=style&index=0&rel=stylesheet%2Fless&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports